import MaintenanceMenuPanel from 'src/components/MaintenanceMenus/MaintenanceMenuPanel/MaintenanceMenuPanel';
import { connect } from 'react-redux';
import { IStoreState } from 'src/store';
import { MenusActionCreator, AppointmentActionCreator } from 'src/store/states';

const mapStateToProps = (state: IStoreState) => ({
    menus: state.Menus.allMenus.menus,
    checkedMileageMenu: state.Menus.checkedMileageMenu,
    checkedConditionalMenus: state.Menus.checkedConditionalMenus,
    apptOps: state.Appointment.ApptOps,
    specDefaultDept: state.Specs.specs !== undefined ? state.Specs.specs.departmentFlag : '',
    specData: state.Specs.deptSpecs,
    oemServices: state.Specs.specs?.oemServices !== undefined ? state.Specs.specs?.oemServices : '',
    userDefServices: state.Specs.specs?.userDefServices !== undefined ? state.Specs.specs?.userDefServices : '',
    vehicles: state.Vehicles.vehicles,
    selectedVehicle: state.Vehicles.selectedVehicle,
});

const mapDispatchToProps = {
    toggleMenu: MenusActionCreator.ToggleMenu,
    UpdateApptOps: AppointmentActionCreator.UpdateApptOps,
    determineDept: AppointmentActionCreator.DetermineDept,
};

export default connect(mapStateToProps, mapDispatchToProps)(MaintenanceMenuPanel);